import React from "react";
import { themeStyle, themeStyleDark } from "./Components";
import { useSelector } from "react-redux";
import { Grid } from "@mui/material";
import Button from "@mui/material/Button";
import XIcon from "@mui/icons-material/X";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import EmailIcon from "@mui/icons-material/Email";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import { Link, Navigate, useNavigate } from "react-router-dom";

export default function VisitUs(props) {
  const state = useSelector((state) => state);
  const navigate = useNavigate();

  return (
    <div
      className="aboutabout2"
      style={{
        paddingTop: "150px",
        paddingBottom: "0px",

        backgroundColor: "#161616",
        color:
          state.auth.theme == "dark"
            ? themeStyleDark.primaryButtonTextColor
            : themeStyle.primaryButtonTextColor,
      }}
    >
      <div
        style={{
          marginTop: "-100px",
          fontSize: state.auth.isMobile ? "30px" : "40px",
          fontWeight: "bold",
          fontFamily: "Montserrat",
        }}
      >
        COME VISIT OUR CAMPUS
      </div>
      <br />
      <br />
      <div
        style={{
          textAlign: "justify",
          fontSize: state.auth.isMobile ? "20px" : "30px",
          fontWeight: "bold",
          fontFamily: "Montserrat",
          marginBottom: "30px",
          textAlign: "center",
        }}
      >
        Are you ready to take the next step toward your future career?
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
        }}
      >
        <Grid container spacing={5} style={{ width: "90%" }}>
          <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
            <Link
              style={{
                textDecoration: "none",
                color:
                  state.auth.theme == "dark"
                    ? themeStyleDark.primaryButtonTextColor
                    : themeStyle.primaryButtonTextColor,
              }}
              to={"https://www.facebook.com/share/18CgAKnSXB/"}
            >
              <div
                style={{
                  marginLeft: "20px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <FacebookIcon
                  className="nav-icon"
                  style={{
                    fontSize: 35,
                  }}
                />
                <div
                  style={{
                    marginLeft: "10px",
                    marginTop: "5px",
                    fontSize: state.auth.isMobile ? "20px" : "30px",
                    fontFamily: "Acherus Grotesque Regular",
                  }}
                >
                  Facebook
                </div>
              </div>
            </Link>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
            <Link
              style={{
                textDecoration: "none",
                color:
                  state.auth.theme == "dark"
                    ? themeStyleDark.primaryButtonTextColor
                    : themeStyle.primaryButtonTextColor,
              }}
              to={"/contact"}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <LocalPhoneIcon
                  className="nav-icon"
                  style={{
                    fontSize: 35,
                  }}
                />
                <div
                  style={{
                    marginLeft: "10px",
                    marginTop: "5px",
                    fontSize: state.auth.isMobile ? "20px" : "30px",
                    fontFamily: "Acherus Grotesque Regular",
                  }}
                >
                  7022808833 | 7022808844
                </div>
              </div>
            </Link>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
            <Link
              style={{
                textDecoration: "none",
                color:
                  state.auth.theme == "dark"
                    ? themeStyleDark.primaryButtonTextColor
                    : themeStyle.primaryButtonTextColor,
              }}
              to={
                "https://www.instagram.com/bgsworldschoolramnagara?igsh=ODRwNTlwaGdrNnhp"
              }
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <InstagramIcon
                  className="nav-icon"
                  style={{
                    fontSize: 35,
                  }}
                />
                <div
                  style={{
                    marginLeft: "10px",
                    marginTop: "5px",
                    fontSize: state.auth.isMobile ? "20px" : "30px",
                    fontFamily: "Acherus Grotesque Regular",
                  }}
                >
                  Instagram
                </div>
              </div>
            </Link>
          </Grid>
        </Grid>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          margin: "50px 0px 100px 0px",
        }}
      >
        <Button
          onClick={() => {
            navigate("/news_and_events");
          }}
          style={{
            padding: "40px",
            border:
              "2px " + state.auth.theme == "dark"
                ? themeStyleDark.primaryButtonTextColor
                : themeStyle.primaryButtonTextColor + " solid",
            borderRadius: "45px",
            height: "50px",
            fontSize: "20px",
            fontWeight: "bold",
            backgroundColor:
              state.auth.theme == "dark"
                ? themeStyleDark.primaryButtonTextColor
                : themeStyle.primaryButtonTextColor,
            color:
              state.auth.theme == "dark"
                ? themeStyleDark.primaryColor
                : themeStyle.primaryColor,
          }}
        >
          MORE CAMPUS NEWS
        </Button>
      </div>
    </div>
  );
}
